module.exports = __webpack_public_path__ + "static/media/banner.cb83cf2a.jpg";